module.exports = __webpack_public_path__ + "img/dizuo.d4392695.png";